import { Box } from "@mui/material";
import React from "react";

const ViewManualAuth = () => {
  return (
    <>
      <Box style={{ width: "100%", height: "100vh" }}>
        <object
          data={require("./../../../assets/ManualAutorizacionesRENACER.pdf")}
          type="application/pdf"
          width="100%"
          height="100%"
        >
        </object>
      </Box>
    </>
  );
};

export default ViewManualAuth;
